import React from "react";
import { Flex, Text, Switch, FormControl, FormLabel } from "@chakra-ui/react";
import { CheckEligibilityButton } from "./CheckEligibilityButton";
import { useTranslations } from "../../../hooks/useTranslations";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { setHideIneligible } from "src/store/eligibilityToggle";

type EligibilityToggleProps = {
  hideIneligible: boolean;
  onChange: (value: boolean) => void;
};

const EligibilityToggle = ({
  hideIneligible,
  onChange,
}: EligibilityToggleProps): React.ReactElement => {
  return (
    <Flex direction="column" gap={2}>
      <FormControl display="flex" alignItems="center">
        <Switch
          id="eligibility-toggle"
          isChecked={hideIneligible}
          onChange={(e) => onChange(e.target.checked)}
          colorScheme="primary"
        />
        <FormLabel htmlFor="eligibility-toggle" mb="0" ml="3">
          Show eligible schools only
        </FormLabel>
      </FormControl>
    </Flex>
  );
};

export type CheckEligibilityProps = {
  buttonText: string;
  onCheckEligibility: () => void;
  showToggle: boolean;
};

export const CheckEligibility = ({
  buttonText,
  onCheckEligibility,
  showToggle,
}: CheckEligibilityProps): React.ReactElement => {
  const translate = useTranslations();
  const eligibilityToggle = useSelector(
    (state: RootState) => state.eligibilityToggle
  );
  const dispatch = useDispatch();
  return (
    <Flex direction="column" gap={4}>
      <Flex direction="column">
        <Text>{translate((t) => t.eligibility.filter.header)}</Text>
        <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">
          {translate((t) => t.eligibility.filter.body)}
        </Text>
      </Flex>

      {showToggle && (
        <EligibilityToggle
          hideIneligible={eligibilityToggle.hideIneligible}
          onChange={(value) => dispatch(setHideIneligible(value))}
        />
      )}
      <Flex>
        <CheckEligibilityButton
          variant="outline"
          buttonText={buttonText}
          onClick={onCheckEligibility}
        />
      </Flex>
    </Flex>
  );
};
